import './new-package-activity.scss';

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormPackageActivity from "../form-package-activity/form-package-activity";
import { useNewPackageActivity } from './new-package-activity.hook';

export function NewPackageActivity() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewPackageActivity();

  return (
    <div id="NewPackageActivity" className="package-activity">
      <HeaderContent
        title={<h1>New Package Activity</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormPackageActivity />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewPackageActivity;